import React, { useEffect, useState } from "react";
import "./index.css";
import { Card } from "antd";
import axios from "axios";
import Cookies from "universal-cookie";
import moment from "moment";
import { IoIosSearch } from "react-icons/io";
import { loaderReducer } from "../../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import { Pagination } from "antd";
import { searchFilter } from "../../../functions/update";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const dispatch = useDispatch();

  const [allNotifications, setAllNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [totaldata, setTotaldata] = useState(1);
  const [tranId, setTranId] = useState("");
  const [searchPage, setSearchPage] = useState(1);
  const navigate = useNavigate();

  const onChange = (page) => {
    if (tranId) {
      setSearchPage(page);
    } else {
      setPage(page);
    }
  };

  const handleCardClick = (tranId) => {
    navigate(`/work-order`,{state:{tranId}});
  };


  const fetchNotifications = async () => {
    dispatch(loaderReducer(true));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/notification/list-all?page=${page}&perPage=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("RESPODATA-------->", response.data);
      dispatch(loaderReducer(false));
      // Separate read and unread notifications
      const allNotification = response.data.data.allNotifications;
      setTotaldata(response.data.totalCount);
      setAllNotifications(allNotification);
    } catch (error) {
      dispatch(loaderReducer(false));
      console.error("Failed to fetch notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [page]);

  const handleChange = (e) => {
    setTranId(e.target.value);
  };

  const SearchFilterData = async () => {
    dispatch(loaderReducer(true));
    try {
      if (tranId.length > 0) {
        await searchFilter(token, tranId, searchPage)
          .then((res) => {
            dispatch(loaderReducer(false));
            setAllNotifications(res.data.tranId);
            setTotaldata(res.data.total);
          })
          .catch((err) => {
            dispatch(loaderReducer(false));
            console.log(err);
          });
      } else {
        fetchNotifications();
      }
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error);
    }
  };

  useEffect(() => {
    if (tranId) {
      SearchFilterData();
    }
  }, [tranId, searchPage]);

  console.log("page", page, searchPage, tranId);
  return (
    <div>
      <div className="updateContent">
        <div>
          <div className="position-relative mb-4">
            <input
              onChange={handleChange}
              type="search"
              // value={tranId}
              name="searchtext"
              className="search-input form-control"
              placeholder="Search Orders"
            />
            <IoIosSearch className="icon-cls" />
          </div>
          {allNotifications.length === 0
            ? "No data found."
            : allNotifications &&
              allNotifications.map((notification, index) => (
                <div className="mt-3" key={index}>
                  <Card
                    hoverable
                    className="cardcls"
                    onClick={() => handleCardClick(notification.tranId)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="prioritycls text-dark p-0">
                        {moment(notification.createdAt).format("MM/DD/YYYY")}
                      </div>
                      <div
                        className="updatenote"
                        style={{
                          color:
                            notification.type === "Order Created"
                              ? "#1C449C"
                              : "",
                        }}
                      >
                        {notification.type}
                      </div>
                    </div>
                    <div className="mt-2">Order #{notification.tranId}</div>
                    {/* <div className="mt-2">From: Christina Chavira</div> */}
                    {/* <div>Sent: Friday, November 17, 2023 2:23 PM</div> */}
                    {/* <div>To: Connie Ribarro...</div> */}
                  </Card>
                </div>
              ))}
          {/* pagination */}
          <Pagination
            simple
            onChange={onChange}
            defaultCurrent={1}
            total={totaldata}
            className="mt-4"
            showSizeChanger={false}
            style={{ display: "flex", justifyContent: "flex-end" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
